// Cache-busting for media/assets: append ?v=<build timestamp> so a new build
// invalidates the browser/CDN cache of logos, icons, sounds, etc. — including
// external URLs (e.g. media.sec4us.com.br). REACT_APP_BUILD_TS is stamped at
// build time by the Docker build (`RUN REACT_APP_BUILD_TS=$(date …) yarn build`);
// it falls back to "dev" locally.
export const BUILD_TS = process.env.REACT_APP_BUILD_TS || "dev";

// Append the version marker to a URL. Leaves falsy values and data: URIs
// untouched (a data URI must not carry a query string).
export function withV(url) {
  if (!url || typeof url !== "string" || url.startsWith("data:")) return url;
  return url + (url.includes("?") ? "&" : "?") + "v=" + BUILD_TS;
}
